import $ from 'jquery';
import slick from 'slick-carousel';
import config from '../app-config';

function setSliderTemplates() {
    const templates = $('.esti-templates-list');

    templates.slick({
        dots: false,
        arrows: true,
        variableWidth: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        edgeFriction: 0,
        speed: 400,
        touchMove: false,
        prevArrow: '<div class="esti-templates-list__prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="12" height="20" viewBox="0 0 8 14"> <path d="M7.530,1.311 C7.530,1.311 1.937,6.904 1.937,6.904 C1.937,6.904 7.530,12.497 7.530,12.497 C7.837,12.804 7.837,13.301 7.530,13.607 C7.224,13.914 6.726,13.914 6.420,13.607 C6.420,13.607 0.513,7.701 0.513,7.701 C0.403,7.663 0.299,7.608 0.211,7.520 C0.042,7.351 -0.025,7.125 -0.007,6.904 C-0.025,6.683 0.042,6.457 0.211,6.288 C0.299,6.201 0.403,6.145 0.513,6.108 C0.513,6.108 6.420,0.201 6.420,0.201 C6.726,-0.106 7.224,-0.106 7.530,0.201 C7.837,0.508 7.837,1.004 7.530,1.311 Z" id="path-1" fill-rule="evenodd" fill="#332f36"/></svg></div>',
        nextArrow: '<div class="esti-templates-list__next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="12" height="20" viewBox="0 0 8 14"> <path d="M7.539,7.520 C7.451,7.608 7.347,7.663 7.237,7.701 C7.237,7.701 1.330,13.607 1.330,13.607 C1.023,13.914 0.527,13.914 0.220,13.607 C-0.087,13.301 -0.087,12.804 0.220,12.497 C0.220,12.497 5.813,6.904 5.813,6.904 C5.813,6.904 0.220,1.311 0.220,1.311 C-0.087,1.004 -0.087,0.508 0.220,0.201 C0.527,-0.106 1.023,-0.106 1.330,0.201 C1.330,0.201 7.237,6.108 7.237,6.108 C7.347,6.145 7.451,6.201 7.539,6.288 C7.708,6.457 7.775,6.683 7.757,6.904 C7.775,7.125 7.708,7.351 7.539,7.520 Z" id="path-1" fill-rule="evenodd" fill="#332f36"/></svg></div>',
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 200
                }
            }
        ]
    });
}

function setScrollbar() {

    // var conveyor = $('.slick-track', $('.esti-templates-list')),
    //     item = $('.esti-template');
    //
    // conveyor.css("width", item.length * parseInt(item.css("width")));
    //
    // var sliderOpts = {
    //     step: 1,
    //     max: (item.length * parseInt(item.css("width"))) - parseInt($('.viewer').css("width")),
    //     slide: function(e, ui) {
    //         conveyor.css("left", "-" + ui.value + "px");
    //     }
    // };



    // const item = $('.esti-template');
    // const width = (item.length * parseInt(item.css("width")));
    //
    // $('.esti-templates-list').css('width', width);
    //
    // $(document).ready(function () {
    //     $('.viewer').niceScroll('.esti-templates-list', {
    //         cursorcolor: "#ffffff",
    //         cursoropacitymin: 1,
    //         cursorwidth: "34px",
    //         cursorborder: "2px solid #332f36",
    //         cursorborderradius: "17px",
    //         zindex: 9000,
    //         touchbehavior: true,
    //         autohidemode: false,
    //         cursorfixedheight: 150,
    //         cursordragontouch: true,
    //         railoffset: 100/100
    //     });
    // });


}

function init() {
    if ($('.esti-templates-list').length > 0) setSliderTemplates();
    setScrollbar();

    $('.view-change').on('click', function () {
        if ($(this).parent().hasClass('-list-view')) {
            $('.esti-templates-list').slick('unslick');
            // $('.esti-templates-list').css('width', '440px');
        } else {
            setSliderTemplates();
            setScrollbar();
        }
    });

}

export {init};


// WEBPACK FOOTER //
// ./src/_app/layout/slider-templates.js